import React from 'react';

/* Toggle 스위치 — checked 시 orange-500, 해제 시 mono-300. 작은 인라인 컨트롤용.
   on/off 가 한눈에 구분되어 다중선택 SelectionCheckbox 와 시각적으로 명확히 분리됨.
   사용처: 어드민 추천 토글 등. */
export default function Toggle({ checked, onChange, disabled = false, size = 'md', className = '' }) {
  const dims = size === 'sm'
    ? { w: 'w-8', h: 'h-4', knob: 'w-3 h-3', translate: 'translate-x-4' }
    : { w: 'w-9', h: 'h-5', knob: 'w-3.5 h-3.5', translate: 'translate-x-4' };

  const handleClick = (e) => {
    e.stopPropagation?.();
    if (disabled) return;
    onChange?.(!checked, e);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={handleClick}
      className={`relative inline-flex items-center ${dims.w} ${dims.h} rounded-full transition-colors shrink-0
        ${checked ? 'bg-orange-500' : 'bg-mono-300'}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}`}
    >
      <span
        className={`inline-block ${dims.knob} bg-white rounded-full shadow-sm transform transition-transform
          ${checked ? dims.translate : 'translate-x-0.5'}`}
      />
    </button>
  );
}
